// `toggle` no burbujea: hace falta la fase de captura.
// Sin atributo `name` a propósito — su grupo es global y el meganav clona el panel.
document.addEventListener(
  'toggle',
  (event) => {
    const abierto = event.target;
    if (abierto.matches('[data-nav-desktop-details]')) {
      if (abierto.open) alinearPanel(abierto);
      return;
    }
    if (!abierto.open || !abierto.classList.contains('mega-menu__tab')) return;
    for (const hermano of abierto.parentElement.children) {
      if (hermano !== abierto && hermano.tagName === 'DETAILS') hermano.open = false;
    }
  },
  true,
);

// Las pestañas se abren al pasar el mouse, como el menú que este reemplaza. Con click, un
// segundo click sobre la pestaña abierta la cerraba y el panel quedaba en blanco.
document.addEventListener('pointerover', (event) => {
  const resumen = event.target.closest?.('.mega-menu__tab-summary');
  // El handler de `toggle` se encarga de cerrar las hermanas.
  if (resumen && !resumen.parentElement.open) resumen.parentElement.open = true;
});

// Sin esto el click nativo del <summary> cierra la pestaña que el hover acaba de abrir.
// El <summary> no navega a ningún lado, asi que no se pierde nada. Va en captura porque
// `NavigationDesktopParent` corta la propagacion en el <li> de la raiz.
document.addEventListener(
  'click',
  (event) => {
    const resumen = event.target.closest?.('.mega-menu__tab-summary');
    if (resumen && resumen.parentElement.open) event.preventDefault();
  },
  true,
);

/**
 * Publica la posición del ítem de menú y el borde derecho de la barra de navegación, para que
 * `.mega-menu--leftparent/--center/--right` los resuelvan con `clamp()`.
 * Sólo se puede medir con el panel abierto: antes no tiene caja.
 * @param {HTMLDetailsElement} details - El `<details>` de la raíz recién abierta
 */
function alinearPanel(details) {
  const panel = details.querySelector('[data-meganav-desktop]');
  const summary = details.querySelector(':scope > summary');
  if (!panel || !summary) return;
  const origen = panel.parentElement.getBoundingClientRect();
  const trigger = summary.getBoundingClientRect();
  panel.style.setProperty('--trigger-left', `${trigger.left - origen.left}px`);
  panel.style.setProperty('--trigger-width', `${trigger.width}px`);
  // `right` en Qikify no se alinea con el item sino con el borde derecho de la barra.
  const barra = details.closest('.nav--combined') ?? details.closest('[data-nav]');
  if (barra) {
    panel.style.setProperty('--nav-right', `${barra.getBoundingClientRect().right - origen.left}px`);
  }
}

// El ancho del contenedor y la posición del ítem cambian con el viewport, y el panel
// abierto no se cierra al redimensionar.
let pendiente;
window.addEventListener('resize', () => {
  clearTimeout(pendiente);
  pendiente = setTimeout(() => {
    document.querySelectorAll('[data-nav-desktop-details][open]').forEach(alinearPanel);
  }, 100);
});
